import React from "react";
import PropTypes from "prop-types";
import Skills from "./skills";
import { useI18n } from "../i18n/LanguageContext";

const SkillsCard = ({ data }) => {
  const { t } = useI18n();
  return (
    <div className="flex flex-row">
      <p className="self-center mr-10">{t("skills.title")}</p>

      <div className="card-text">
        {data !== undefined ? (
          <Skills skills={data} />
        ) : (
          <div>{t("skills.empty")}</div>
        )}
      </div>
    </div>
  );
};
SkillsCard.propTypes = {
  data: PropTypes.array,
};

export default SkillsCard;
